import { render, staticRenderFns } from "./UserChipList.vue?vue&type=template&id=f044982c&scoped=true"
import script from "./UserChipList.vue?vue&type=script&lang=js"
export * from "./UserChipList.vue?vue&type=script&lang=js"
import style0 from "./UserChipList.vue?vue&type=style&index=0&id=f044982c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f044982c",
  null
  
)

export default component.exports